<template>
  <div class="cx-col-md-3 cx-col-sm-6 cx-col-xs-6 cx-div">
    <a v-bind="linkProps(link)" :title="title" :tabindex="tabindex">
      <cx-img width="500" 
        class="-round-corner" 
        :imgSrc="getMediaHost(image, 'MGTO_MEDIA')" 
        :alt="title"
        @load.native="imgLoad"
        :imgHolder="false"
      ></cx-img>
    </a>   
  </div>
</template>

<script>
export default {
  name: 'main-footer-banner',
  created() {
    console.log('[banner] created');
  },
  beforeDestroy() {
    console.log('[banner] destory');
  },
  props: {
    link: {
      type: String,
      default: '#'
    },
    image: {
      teyp: String,
      require: true
    },
    title: {
      type:String,
      default: ''
    },
    updateHeight: {
      type: Boolean,
      default: false,
    },
    tabindex: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    imgLoad: function() {
      this.updateHeight && this.$parent && this.$parent.updateRowHeight();
    },
  },
}
</script>